// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 589 ? "saturday-course-finder" : chunkId) + "." + {"29":"66fdcfd4","510":"26e3ea49","589":"020926da","694":"ac77b3ca","786":"78753b8e","951":"1a77771a"}[chunkId] + ".chunk.js";
};